/**
 * The family's delivery instructions for the courier ("buzzer 1203"), typed on
 * the family delivery page and kept on the case's `delivery_note` as one
 * `Family: …` line under whatever staff wrote (T-107).
 *
 * Mirrors packages/nestjs/src/delivery-scheduling/delivery-instructions.util.ts,
 * which writes the line and builds the Groupe V driver note from it.
 */

export const MAX_DELIVERY_INSTRUCTIONS = 200;

const FAMILY_LINE = /^Family:[ \t]*(.*)$/i;

/** Splits a delivery note into the staff part and the family's line. */
export const splitDeliveryNote = (
  note: string | null | undefined
): { staff: string; family: string | null } => {
  const lines = (note ?? '').split(/\r?\n/);
  let family: string | null = null;
  const staff: string[] = [];
  for (const line of lines) {
    const match = FAMILY_LINE.exec(line.trim());
    if (match) family = match[1].trim() || null;
    else staff.push(line);
  }
  return { staff: staff.join('\n').trim(), family };
};

/** The family's instructions on a delivery note, or '' when there are none. */
export const familyInstructionsFrom = (note: string | null | undefined): string =>
  splitDeliveryNote(note).family ?? '';
